define('view/controller/booking/datetime/classes/TimeClassesProviderItemView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Classes provider item view
     *
     * @class TimeClassesProviderItemView
     */
    return LayoutView.extend({

        template: '#time_classes_provider_item_view',

        onShow: function () {
            this.$el.css({
                'top': this.getOption('top') + '%',
                'height': this.getOption('height') + '%',
                'left': this.getOption('index') * this.$el.outerWidth()
            });
        },

        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);
            if (this.getOption('provider')) {
                result.provider = this.getOption('provider').toJSON();
            }

            return result;
        }

    });

});
